export default (string: string): string => string.split(/(?=[A-Z])/).join(' ');
